import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";

export const DublinNoteContent: NoteContent[] = [
  {
    title: "January 14, 2025",
    date: "January 14, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          "Dublin Castle was built in the 1200s,\n It has a secret underground tunnel,\n The Vikings first settled here,\n (Trivia for the big fat quiz with the crew)",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "February 5, 2025",
    date: "February 5, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          "Dublin Crew Coffee Run\n 3FE (Georges St) – For ‘I need focus’ days\n Bewley’s (Grafton St) – Classic Irish breakfast tea\n Proper Order (Smithfield) – Secret weapon for night shoots\n P.S. Robbie takes his black with one sugar",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "February 17, 2025",
    date: "February 17, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          "Dublin Castle visit - do a shot from beneath the floorboards in Bermingham Tower. High tension, perspective of rats under the floorboards. Accessible from chapel if we get father's permission. Michael (stuntman) volunteers there so has chapel keys. Dirty and damp down there. Would work well for handheld shot. Use 8mm lens for added grit.",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "February 29, 2025",
    date: "February 29, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          "Handling Robbie’s Leading Man Syndrome…\n Start with ‘Your idea made me think…’\n Remind him Pearse was humble\n Play along with his method acting stuff, it’s not my style but he needs it.",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "March 22, 2025",
    date: "March 22, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          " Elske (Do Not Text)\n Return her sweater\n Apologize again\n Explain why I panicked\n God, I hate this.",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "April 13, 2025",
    date: "April 13, 2025 12:00 PM", // Placeholder time added
    content: [
      {
        entry:
          "Michael’s stunt replacement (Sean Finnigan):\n Loves parkour – use for chase scenes\n Allergic to horses (rewrite cavalry charge?)\n Note: best if Michael shadows him for everything for first few weeks, inexperienced but can be trained up fast",
      },
    ],
    locked: false,
    unclickable: false,
  },
];
